// import { loadData, saveData } from '@utils/localstorageHelper'
import { Toast, Modal } from 'antd-mobile'
import initWeixinShare from '@utils/share'
import tools from '@utils/tools'
import {
    apiVideoClassify, apiLiveClassify, apiCourseList, apiVideoDesc,
    apiLiveDesc, apiCourseChapter, apiLiveChapter, apiCommentList,
    apiComment, apiCollect, apiVideoAuth, apiLiveRoomAuth,
    getAudioPoetryBySrcId, listeningOfAdd, listeningOfRemove,
    listeningOfGet, listeningOfCheckAuth
} from '@api'
let firstItem, plainList = []
export default {
    namespace: 'course',
    state: {
        tabIdx: 'init',
        to_id: 0,
        classifyList: [],
        mainIdx: 0,
        currentSubClassify: [],
        subIdx: 0,
        currentCourseList: [],
        videoDesc: {},
        liveDesc: {},
        videoTeacher: {},
        commentList: [],
        commentTotal: '',
        playingUrl: '',//当前播放视频
        playingId: 0,
        playingCourseId: '',
        chapterList: [],
        chapterLevel: 0,
        refreshFlag: false,
        rootId: '',
        replyName: '',
        currentPlainList: [],//当前打平的音频列表
        addListenList: {},//课程详情页已经添加到在听列表的音频
        removeListenList: {},//已经从在听列表移除的音频
        video_src_id: 0,//资源ID
        default_video_img: "",//listening默认封面图
        poetryObj: {
            video_src_id: 0,
            audio_original: '<p>暂无原文</p>',
            audio_translation: '<p>暂无译文</p>',
            audio_annotate: '<p>暂无注释</p>',
            audio_appreciation: '<p>暂无赏析</p>',
        },
    },
    reducers: {
        querySuccess(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
        setCourseType(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
        GENERATE_MAIN_CLASSIFY(state, { classifyList, kindLevel }) {
            if (classifyList.length > 0 && classifyList[0].id != -1) {
                classifyList.unshift({ id: 0, kind_name: '全部' })
            }
            return {
                ...state,
                kindLevel,
                classifyList
            }
        },
        GENERATE_SUB_CLASSIFY(state) {
            let currentSubClassify = state.classifyList[state.mainIdx] && state.classifyList[state.mainIdx].children
            if (currentSubClassify && currentSubClassify[0].id != -1) {
                currentSubClassify.unshift({ id: 0, kind_name: '全部' })
            }
            return {
                ...state,
                subIdx: 0,//子分类归0
                currentCourseList: [],
                currentSubClassify
            }
        },
        FIND_TOGGLE_ROW(state, { id }) {
            toggleChapter(state.chapterList, id)
            return {
                ...state,
                refreshFlag: !state.refreshFlag
            }
        },
        FIND_CLICK_VIDEO(state, { id }) {
            clearAllVideo(state.chapterList)
            findVideo(state.chapterList, id)
            return {
                ...state,
                refreshFlag: !state.refreshFlag
            }
        }
    },
    effects: dispatch => ({
        //直播点播大分类切换
        async toggleCourseTab({ idx, to_id }, state) {
            dispatch.course.querySuccess({ payload: { tabIdx: idx, to_id } })
            if (idx == 0) {
                dispatch.course.getVideoCourseKind()
            } else {
                dispatch.course.getLiveCourseKind()
            }
        },
        //主分类切换
        chooseMainClassify({ mainIdx }, state) {
            Toast.loading('加载中', 0)
            dispatch.course.querySuccess({ payload: { mainIdx } })
            dispatch.course.GENERATE_SUB_CLASSIFY()
            dispatch.course.getCurrentCourseList()
        },
        //子分类切换
        chooseSubClassify({ subIdx }, state) {
            Toast.loading('加载中', 0)
            dispatch.course.querySuccess({ payload: { subIdx } })
            dispatch.course.getCurrentCourseList()
        },
        //查询点播分类
        async getVideoCourseKind(params, state) {
            Toast.loading('加载中', 0)
            let res = await apiVideoClassify()
            if (res.errcode === 0) {
                dispatch.course.GENERATE_MAIN_CLASSIFY({ classifyList: res.result.list, kindLevel: res.result.kind_level })
                dispatch.course.GENERATE_SUB_CLASSIFY()
                dispatch.course.getCurrentCourseList()
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //查询直播分类
        async getLiveCourseKind(params, state) {
            Toast.loading('加载中', 0)
            let res = await apiLiveClassify()
            if (res.errcode === 0) {
                dispatch.course.GENERATE_MAIN_CLASSIFY({ classifyList: res.result.list, kindLevel: res.result.kind_level })
                dispatch.course.GENERATE_SUB_CLASSIFY()
                dispatch.course.getCurrentCourseList()
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //查询当前分类下课的列表
        async getCurrentCourseList(params, state) {
            let mainId = state.course.mainIdx > 0 && state.course.classifyList && state.course.classifyList[state.course.mainIdx] && state.course.classifyList[state.course.mainIdx].id
            let subId = state.course.subIdx > 0 && state.course.classifyList && state.course.classifyList[state.course.mainIdx] && state.course.classifyList[state.course.mainIdx].children[state.course.subIdx] && state.course.classifyList[state.course.mainIdx].children[state.course.subIdx].id
            mainId = mainId ? mainId : ""
            subId = subId ? subId : ""
            let res = await apiCourseList({
                kind_level: state.course.kindLevel,
                main_id: mainId + '',
                sub_id: subId + '',
                course_type: (state.course.tabIdx == 1 ? 2 : 0) + '',
            })
            if (res.errcode === 0) {
                dispatch.course.querySuccess({ payload: { currentCourseList: res.result.list } })
            } else {
                Toast.info(res.errmsg, 1)
            }
            Toast.hide()
        },
        //获取视频详情
        async getVideoDesc({ id, url }, state) {
            let res = await apiVideoDesc({ course_id: id })
            if (res.errcode === 0) {
                console.log(res, 'courseItem')
                let videoDesc = res.result.course
                dispatch.course.querySuccess({ payload: { videoDesc: res.result.course, videoTeacher: res.result.teacher } })
                let params = {
                    title: videoDesc.name,
                    desc: videoDesc.brief,
                    link: url,
                    imgUrl: videoDesc.img_url,
                    success: function () {
                        console.log("分享成功!");
                    }
                }
                if (!tools.isWeiXin()) {
                    return;
                }
                initWeixinShare(params)
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //获取直播详情
        async getLiveDesc({ id, url }, state) {
            let res = await apiLiveDesc({ course_id: id })
            if (res.errcode === 0) {
                console.log(res, 'liveItem')
                let videoDesc = res.result.course
                dispatch.course.querySuccess({ payload: { liveDesc: res.result.course, videoTeacher: res.result.teacher } })
                let params = {
                    title: videoDesc.name,
                    desc: videoDesc.brief,
                    link: url,
                    imgUrl: videoDesc.img_url,
                    success: function () {
                        console.log("分享成功!");
                    }
                }
                if (!tools.isWeiXin()) {
                    return;
                }
                initWeixinShare(params)
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //获取章节列表
        async getChapterList({ id, type = '', defaultVideoId }, state) {
            let url, res
            if (id == -1) {
                res = await listeningOfGet({});
                if (res && res.errcode == 0 && res.result.list) {
                    res.result.list = res.result.list.map(item => {
                        item.listening_id = item.id;
                        item.id = item.video_id;
                        return item;
                    })
                }
            } else if (type == 'live') {
                res = await apiLiveChapter({ course_id: id })
            } else {
                res = await apiCourseChapter({ course_id: id })
            }
            if (res.errcode === 0) {
                generatePlainList(res.result.list, defaultVideoId)
                dispatch.course.querySuccess({
                    payload: {
                        chapterList: res.result.list,
                        chapterLevel: res.result.chapter_level,
                        currentPlainList: plainList,
                        default_video_img: res.result.default_video_img,
                    }
                })
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //获取音视频释义
        async getAudioPoetryBySrcId(params, state) {
            let video_src_id = state.course.video_src_id;
            if (video_src_id > 0 && state.course.poetryObj.video_src_id != video_src_id) {
                let res = await getAudioPoetryBySrcId({ video_src_id });
                if (res.errcode == 0) {
                    let result = res.result;
                    dispatch.course.querySuccess({
                        payload: {
                            poetryObj: {
                                ...state.poetryObj,
                                video_src_id,
                                audio_original: result.audio_original,
                                audio_translation: result.audio_translation,
                                audio_annotate: result.audio_annotate,
                                audio_appreciation: result.audio_appreciation,
                            }
                        }
                    })
                }
            }
        },
        //在听 - 添加到在听列表
        async listeningOfAdd({ video_id, course_id }, state) {
            if (video_id > 0 && course_id > 0) {
                let res = await listeningOfAdd({ video_id, course_id });
                if (res.errcode == 0) {
                    let addListenList = state.course.addListenList;
                    addListenList[video_id + ''] = 1;
                    Toast.info("已添加到在听列表", 1.5)
                    dispatch.course.querySuccess({ payload: { addListenList } })
                } else {
                    Toast.info(res.errmsg, 1)
                }
            }
        },
        //在听 - 从在听列表移除
        async listeningOfRemove({ listening_id, video_id, course_id }, state) {
            if (listening_id > 0 && course_id == -1) {
                let res = await listeningOfRemove({ id: listening_id });
                if (res.errcode == 0) {
                    let removeListenList = state.course.removeListenList;
                    removeListenList[listening_id + ''] = 1;
                    Toast.info("已从在听列表移除", 1.5)
                    let addListenList = state.course.addListenList;
                    delete addListenList[video_id + ''];
                    dispatch.course.querySuccess({ payload: { removeListenList, addListenList } })
                } else {
                    Toast.info(res.errmsg, 1)
                }
            }
        },
        //获取评论列表
        async getCommentList({ id }, state) {
            let res = await apiCommentList({ course_id: id });
            if (res.errcode === 0) {
                dispatch.course.querySuccess({ payload: { commentList: res.result.list } })
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //课程下方评论
        async submitComment({ message, id, cb }, state) {
            let res = await apiComment({ course_id: id, message: message, root_id: state.course.rootId, at_id: state.course.atId });
            if (res.errcode === 0) {
                Toast.show('留言成功', 1);
                dispatch.course.getCommentList({ id })
                cb()
            } else {
                Toast.show(res.errmsg, 1);
            }
        },
        //回复评论
        replyComment({ rootId, name }) {
            dispatch.course.querySuccess({ payload: { rootId, replyName: name } })
        },
        //回复评论的评论
        replyCommentAgain({ rootId, atId, name }) {
            dispatch.course.querySuccess({ payload: { rootId, atId, replyName: name } })
        },
        //切换收藏课程
        async toggleCollect({ status, id, type }, state) {
            let res = await apiCollect({ course_id: id, status: status });
            if (res.errcode === 0) {
                if (type == 'living') {
                    dispatch.course.getLiveDesc({ id })
                } else {
                    dispatch.course.getVideoDesc({ id })
                }
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //点击封面查找第一个视频
        async getFirstVideoUrl({ courseId, defaultVideoId, cb }, state) {
            if (defaultVideoId > 0) {
                let rest = positionDefaultVideoById(state.course.chapterList, defaultVideoId);
                if (!rest) {
                    findFirstVideo(state.course.chapterList)
                }
            } else {
                findFirstVideo(state.course.chapterList)
            }
            dispatch.course.FIND_CLICK_VIDEO({ id: firstItem.id })
            dispatch.course.querySuccess({
                payload: {
                    playingId: firstItem.id,
                    playingCourseId: courseId,
                    video_img: firstItem.video_img || '',
                    video_src_id: firstItem.video_src_id,
                }
            })
            dispatch.course.checkVideoAuth({ courseId, videoId: firstItem.id, listening_id: firstItem.listening_id, cb })
        },
        //章节列表折叠
        async toggleChapterOpen({ id }, state) {
            dispatch.course.FIND_TOGGLE_ROW({ id })
        },
        //点击播放当前视频
        async choosePlayingVideo({ courseId, videoId, video_img, video_src_id, listening_id, cb }, state) {
            dispatch.course.checkVideoAuth({ courseId, videoId, listening_id, cb })
            dispatch.course.FIND_CLICK_VIDEO({ id: videoId })
            dispatch.course.querySuccess({
                payload: {
                    playingId: videoId,
                    playingCourseId: courseId,
                    video_img: video_img || '',
                    video_src_id,
                }
            })
        },
        //视频鉴权
        async checkVideoAuth({ courseId, videoId, listening_id, cb }) {
            Toast.loading('加载中', 0)
            if (courseId == -1) {
                let res = await listeningOfCheckAuth({ course_id: courseId, video_id: videoId });
                if (res.errcode === 0) {
                    dispatch.course.getAudioPoetryBySrcId();
                    /**
                    * returncode 
                    * 1000鉴权成功
                    * 1001会员已到期
                    * 1002音频已下架
                    * 2001鉴权出错
                    * 0 鉴权成功
                    * 其它
                    */
                    let returncode = res.result.returncode;
                    let errmsg = res.result.message;
                    if ([0,1000].indexOf(returncode) > -1) {
                        dispatch.course.querySuccess({ payload: { playingUrl: res.result.video_url } })
                        Toast.hide()
                    } else if(returncode == 1001){
                        Modal.alert("温馨提示","开通VIP，畅听全部课程",[
                            { text: '取消', onPress: () => {} }, 
                            { text: '确认', onPress: () => window.location.href = "/vip"}
                        ]);
                        Toast.hide()
                    }else {
                        Toast.info(errmsg || `error ${returncode}`, 3)
                    }
                } else {
                    Toast.info(res.errmsg, 2)
                }
            } else {
                let res = await apiVideoAuth({ course_id: courseId, video_id: videoId });
                if (res.errcode === 0) {
                    dispatch.course.getAudioPoetryBySrcId();
                    if (res.result.returncode) {
                        let code = res.result.returncode
                        Toast.info(res.result.returnmsg, 1.5)
                        if (code == 1002) {
                            cb()
                        }
                    } else {
                        dispatch.course.querySuccess({ payload: { playingUrl: res.result[0] && res.result[0].video_url } })
                        Toast.hide()
                    }
                } else {
                    Toast.info(res.errmsg, 1)
                }
            }
        },
        // 直播鉴权
        async checkLiveAuth({ id, history }) {
            let res = await apiLiveRoomAuth({ course_id: id });
            if (res.errcode === 0) {
                if (res.result.returncode) {
                    Toast.info(res.result.returnmsg, 1)
                } else {
                    let item = res.result
                    if (res.result.live_status === 1 && res.result.m3u8) {
                        history.push({ pathname: '/livePlay', state: { live_url: item.m3u8, course_id: id } })
                        dispatch.course.querySuccess({ payload: { playingUrl: res.result.m3u8 } })
                    } else {
                        Toast.info('直播未开始...', 1)
                    }
                }
            } else {
                Toast.info(res.errmsg, 1)
            }
        },
        //置空课程页详细信息
        emptyCourseInfo() {
            dispatch.course.querySuccess({ payload: { playingUrl: '', videoDesc: {}, liveDesc: {} } })
        },
        //播放下一个音频
        nextAudio({ type }, state) {
            let { playingCourseId, currentPlainList, playingId } = state.course
            let nextId = 0;
            let video_src_id = 0;
            let video_img = "";
            let listening_id = 0;
            for (let i = 0; i < currentPlainList.length; i++) {
                if (playingId == currentPlainList[i].id) {
                    if (type == 'pre') {
                        if (i == 0) {
                            Toast.info('当前播放为第一首', 1)
                            return
                        }
                        nextId = currentPlainList[i - 1].id;
                        video_src_id = currentPlainList[i - 1].video_src_id;
                        video_img = currentPlainList[i - 1].video_img || "";
                        listening_id = currentPlainList[i - 1].listening_id;
                    } else {
                        if (i == currentPlainList.length - 1) {
                            Toast.info('当前播放为最后一首', 1)
                            return
                        }
                        nextId = currentPlainList[i + 1].id
                        video_src_id = currentPlainList[i + 1].video_src_id;
                        video_img = currentPlainList[i + 1].video_img || ""
                        listening_id = currentPlainList[i + 1].listening_id;
                    }
                    break
                }
            }
            dispatch.course.checkVideoAuth({ courseId: playingCourseId, videoId: nextId, listening_id, cb: () => { } })
            dispatch.course.querySuccess({
                payload: {
                    playingId: nextId,
                    playingCourseId,
                    video_img,
                    video_src_id,
                }
            })
            dispatch.course.FIND_CLICK_VIDEO({ id: nextId })
        }
    })
}

function findFirstVideo(chapter) {
    firstItem = chapter[0]
    if (chapter[0].children && chapter[0].children.length > 0) {
        findFirstVideo(chapter[0].children)
    }
}

function positionDefaultVideoById(chapter, video_id) {
    if (chapter && chapter.length > 0) {
        for (let k = 0; k < chapter.length; k++) {
            let kObj = chapter[k];
            if (kObj && kObj.video_name && kObj.id == video_id) {
                firstItem = kObj;
                return true;
            }
            if (kObj && kObj.children && kObj.children.length > 0) {
                let rest = positionDefaultVideoById(kObj.children, video_id);
                if (rest) {
                    return true;
                }
            }
        }
        return false;
    };
}

function toggleChapter(chapter, id) {
    for (let i = 0; i < chapter.length; i++) {
        if (chapter[i].id == id) {
            chapter[i].open = !chapter[i].open
            break
        }
        if (chapter[i].children && chapter[i].children.length > 0) {
            toggleChapter(chapter[i].children, id)
        }
    }
}
function clearAllVideo(chapter) {
    for (let i = 0; i < chapter.length; i++) {
        chapter[i].choose = false
        if (chapter[i].children && chapter[i].children.length > 0) {
            clearAllVideo(chapter[i].children)
        }
    }
}
function findVideo(chapter, id) {
    for (let i = 0; i < chapter.length; i++) {
        if (chapter[i].id == id) {
            chapter[i].choose = true
            break
        }
        if (chapter[i].children && chapter[i].children.length > 0) {
            findVideo(chapter[i].children, id)
        }
    }
}
function generatePlainList(chapter, defaultVideoId) {
    let is_default = 0;
    for (let i = 0; i < chapter.length; i++) {

        if (chapter[i].video_name) {
            plainList.push(chapter[i])
        }
        if (chapter[i].children && chapter[i].children.length > 0 && chapter[i].children[0].video_name) {
            chapter[i].open = 0;
        } else {
            chapter[i].open = 1;
        }
        //如果是默认视频
        if (chapter[i].video_name && chapter[i].id == defaultVideoId) {
            chapter[i].open = 1;
            chapter[i].choose = true;
            is_default = 1;
        }
        if (chapter[i].children && chapter[i].children.length > 0) {
            let rest = generatePlainList(chapter[i].children, defaultVideoId)
            if (rest == 1) {
                chapter[i].open = 1;
            }
        }
    }
    return is_default;
}